module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-field', {
    attrs: {
      "grouped": ""
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Personal title"
    }
  }, [_c('b-select', [_c('option', [_vm._v("Mr.")]), _vm._v(" "), _c('option', [_vm._v("Ms.")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Name",
      "expanded": ""
    }
  }, [_c('b-input')], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Email",
      "expanded": ""
    }
  }, [_c('b-input')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-376abec6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/field/examples/ExGroupExpanded.vue
// module id = 1078
// module chunks = 5 226